import { httpPost, httpDownload } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import Moment from 'moment';

import {
    getInvoiceDispute,
    setInvoiceDisputeError,
    setInvoiceDisputeColSearchStr,
    sortInvoiceDisputeItems,
    setInvoiceDisputePageSize,
    setInvoiceDisputeFilter,
    applyInvoiceDisputeFilter,
    applyInvoiceDisputeStatusFilter,
    setDefaultInvoiceDispute
} from "../../../constants/model-reducers/external/invoice/dispute.settings";
import { convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';

const defaultState = () => ({
    isInvoiceDisputeLoaded: false,
    isInvoiceDisputeError: false,
    invoiceDisputeItems: DEFAULT_TABLE_RESULT_MODEL,
    invoiceDisputeColSort: '',
    invoiceDisputeIsSortedAsc: false,
    invoiceDisputeTableFilterList: [],
    invoiceDisputeTableFilterApply: false,
    invoiceDisputeStatusFilterList: [],
    invoiceDisputeTableFilterStatusApply: 0,
});
     
const initialState = defaultState();

export const invoiceDisputeActions = {
    setDefaultInvoiceDispute: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultInvoiceDispute,
            inventoryItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getInvoiceDispute: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().invoiceDispute.invoiceDisputeItems;
        const { invoiceDisputeIsSortedAsc, invoiceDisputeColSort, invoiceDisputeTableFilterList, invoiceDisputeTableFilterApply, invoiceDisputeStatusFilterList, invoiceDisputeTableFilterStatusApply } = state().invoiceDispute;

        var userId = sessionStorage.getItem('UserID');
        const headersToSend = pageUnmount ? {} : { ...Headers };

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: headersToSend,
                SortedColumnName: invoiceDisputeColSort,
                IsSortAscending: invoiceDisputeIsSortedAsc,
                TableFilterList: invoiceDisputeTableFilterList,
                ApplyFilter: invoiceDisputeTableFilterApply,
                StatusFilter: invoiceDisputeStatusFilterList,
                ApplyStatusFilter: invoiceDisputeTableFilterStatusApply,
            };

            var disputeItems = await httpPost('external/dispute/getDisputeInvoiceItems', data);

            dispatch({
                type: getInvoiceDispute,
                disputeItems: Object.keys(disputeItems).length > 0 ? disputeItems : DEFAULT_TABLE_RESULT_MODEL,
                isInvoiceDisputeLoaded: true,
                isInvoiceDisputeError: false
            });
        }

        catch (e) {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });
        }
    },
    setInvoiceDisputeColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { invoiceDisputeItems } = state().invoiceDispute;
        var invoiceDisputeItemsUpd = {
            ...invoiceDisputeItems,
            "Headers": {
                ...invoiceDisputeItems.Headers,
                [key]: {

                    ...invoiceDisputeItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInvoiceDisputeColSearchStr,
            data: invoiceDisputeItemsUpd,
            isInvoiceDisputeError: false,
            isInvoiceDisputeLoaded: true
        });
    },
    sortInvoiceDisputeItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().invoiceDispute.invoiceDisputeItems.Pagination;
        const { invoiceDisputeItems, invoiceDisputeTableFilterList, invoiceDisputeTableFilterApply, invoiceDisputeStatusFilterList, invoiceDisputeTableFilterStatusApply } = state().invoiceDispute;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: invoiceDisputeItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...invoiceDisputeItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: invoiceDisputeTableFilterList,
            ApplyFilter: invoiceDisputeTableFilterApply,
            StatusFilter: invoiceDisputeStatusFilterList,
            ApplyStatusFilter: invoiceDisputeTableFilterStatusApply,
        };
        var resInvoiceDisputeItems = await httpPost('external/dispute/getDisputeInvoiceItems', data);
        if (resInvoiceDisputeItems.ok === false) {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });
        } else {
            dispatch({
                type: sortInvoiceDisputeItems,
                invoiceDisputeItems: Object.keys(resInvoiceDisputeItems).length > 0 ? resInvoiceDisputeItems : DEFAULT_TABLE_RESULT_MODEL,
                invoiceDisputeColSort: columnClicked,
                invoiceDisputeIsSortedAsc: isSortedAsc,
                isInvoiceDisputeLoaded: true
            });
        }
    },

    resizeInvoiceDisputePage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInvoiceDisputePageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractInvoiceDispute: () => async (dispatch, state) => {
        const { Headers } = state().invoiceDispute.invoiceDisputeItems;
        const { invoiceDisputeIsSortedAsc, invoiceDisputeColSort, invoiceDisputeTableFilterList, invoiceDisputeTableFilterApply, invoiceDisputeStatusFilterList, invoiceDisputeTableFilterStatusApply } = state().invoiceDispute;

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(), 
            activeDateFormat?.Name || "YYYY-MM-DD", 
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');  
        var filename = `ATEM ${dealName} Dispute Extract – ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers,
                FirstFollowUpDate: Headers.FirstFollowUpDate = {
                    ...Headers.FirstFollowUpDate,
                    hidden: false,
                    order: 50,
                },
                SecondFollowUpDate: Headers.SecondFollowUpDate = {
                    ...Headers.SecondFollowUpDate,
                    hidden: false,
                    order: 51,
                },
                ThirdFollowUpDate: Headers.ThirdFollowUpDate = {
                    ...Headers.ThirdFollowUpDate,
                    hidden: false,
                    order: 52,
                },
                FourthFollowUpDate: Headers.FourthFollowUpDate = {
                    ...Headers.FourthFollowUpDate,
                    hidden: false,
                    order: 53,
                },
            },
            SortedColumnName: invoiceDisputeColSort,
            IsSortAscending: invoiceDisputeIsSortedAsc,
            FileName: filename,
            TableFilterList: invoiceDisputeTableFilterList,
            ApplyFilter: invoiceDisputeTableFilterApply,
            StatusFilter: invoiceDisputeStatusFilterList,
            ApplyStatusFilter: invoiceDisputeTableFilterStatusApply,
        };

        httpDownload('external/dispute/getDisputeExtractInvoiceItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addInvoiceDisputeFilter: (tableFilter) => (dispatch, state) => {
        const { invoiceDisputeTableFilterList } = state().invoiceDispute;

        var filterList = [...invoiceDisputeTableFilterList, tableFilter];

        dispatch({
            type: setInvoiceDisputeFilter,
            filterList: filterList
        })
    },

    removeInvoiceDisputeFilter: (removeIndex) => (dispatch, state) => {
        const { invoiceDisputeTableFilterList } = state().invoiceDispute;

        var filterList = invoiceDisputeTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setInvoiceDisputeFilter,
            filterList: filterList
        })
    },

    applyInvoiceDisputeFilter: (isApply) => (dispatch, state) => {
        const { invoiceDisputeTableFilterList } = state().invoiceDispute;

        dispatch({
            type: applyInvoiceDisputeFilter,
            applyFilter: isApply,
            filterList: isApply ? invoiceDisputeTableFilterList : []
        });
    },
    applyInvoiceDisputeStatusFilter: (isStatusApply) => (dispatch, state) => {

        dispatch({
            type: applyInvoiceDisputeStatusFilter,
            applyStatusFilter: isStatusApply,
        });
    },

    saveInvoiceDisputeCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().invoiceDispute.invoiceDisputeItems;
        const { invoiceDisputeIsSortedAsc, invoiceDisputeColSort, invoiceDisputeTableFilterList, invoiceDisputeTableFilterApply, invoiceDisputeStatusFilterList, invoiceDisputeTableFilterStatusApply } = state().invoiceDispute;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.DisputeInvoiceManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/dispute/saveDisputeCustomizeColumns', customizeFormData);

            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: invoiceDisputeColSort,
                IsSortAscending: invoiceDisputeIsSortedAsc,
                TableFilterList: invoiceDisputeTableFilterList,
                ApplyFilter: invoiceDisputeTableFilterApply,
                StatusFilter: invoiceDisputeStatusFilterList,
                ApplyStatusFilter: invoiceDisputeTableFilterStatusApply,
            };

            var disputeItems = await httpPost('external/dispute/getDisputeInvoiceItems', data);

            dispatch({
                type: getInvoiceDispute,
                disputeItems: Object.keys(disputeItems).length > 0 ? disputeItems : DEFAULT_TABLE_RESULT_MODEL,
                isInvoiceDisputeLoaded: true,
                isInvoiceDisputeError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });
        }
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInvoiceDispute:
            return {
                ...state,
                invoiceDisputeItems: action.disputeItems,
                isInvoiceDisputeLoaded: action.isInvoiceDisputeLoaded,
                isInvoiceDisputeError: action.isInvoiceDisputeError
            };
        case setInvoiceDisputeError:
            return {
                ...state,
                isInvoiceDisputeError: action.isInvoiceDisputeError,
                isInvoiceDisputeLoaded: action.isInvoiceDisputeLoaded
            }
        case setInvoiceDisputeColSearchStr:
            return {
                ...state,
                invoiceDisputeItems: action.data,
                isInvoiceDisputeLoaded: action.isInvoiceDisputeLoaded,
                isInvoiceDisputeError: action.isInvoiceDisputeError
            }
        case sortInvoiceDisputeItems:
            return {
                ...state,
                invoiceDisputeItems: action.invoiceDisputeItems,
                invoiceDisputeColSort: action.invoiceDisputeColSort,
                invoiceDisputeIsSortedAsc: action.invoiceDisputeIsSortedAsc,
                isInvoiceDisputeLoaded: action.isInvoiceDisputeLoaded
            }
        case setInvoiceDisputePageSize:
            return {
                ...state,
                invoiceDisputeItems: {
                    ...state.invoiceDisputeItems,
                    Pagination: {
                        ...state.invoiceDisputeItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setInvoiceDisputeFilter:
            return {
                ...state,
                invoiceDisputeTableFilterList: action.filterList
            }
        case applyInvoiceDisputeFilter:
            return {
                ...state,
                invoiceDisputeTableFilterApply: action.applyFilter,
                invoiceDisputeTableFilterList: action.filterList
            }
        case applyInvoiceDisputeStatusFilter:
            return {
                ...state,
               invoiceDisputeTableFilterStatusApply: action.applyStatusFilter,
            }
        case setDefaultInvoiceDispute:
            return initialState;
        default:
            return state;
    }
};